import { motion } from "framer-motion";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import { FAQS, waUrl } from "../data";

export const Faq = () => {
  return (
    <section id="faq" className="bg-background py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4">
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-electric">Preguntas frecuentes</span>
            <h2 className="font-heading font-bold text-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-5">
              Resolvemos<br />tus dudas.
            </h2>
            <p className="mt-6 text-muted-foreground leading-relaxed">
              ¿No encuentras lo que buscas? Escríbenos por WhatsApp y te respondemos enseguida.
            </p>
            <a href={waUrl("Hola, tengo una duda sobre vuestros servicios.")} target="_blank" rel="noopener noreferrer" data-testid="faq-whatsapp-button" className="inline-flex items-center gap-2 mt-6 bg-[#25D366] text-white font-semibold px-6 py-3 hover:brightness-95 transition-[filter] duration-300">
              Preguntar por WhatsApp
            </a>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                >
                  <AccordionItem value={`item-${i}`} className="border-b border-border" data-testid={`faq-item-${i}`}>
                    <AccordionTrigger className="text-left font-heading font-semibold text-ink text-lg hover:no-underline py-6">
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                </motion.div>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
